export default (
  state = {
    status: 'LOADING',
    language: '',
    tenantId: '',
    name: '',
    logoURL: '',
    imageURL: '',
    canRefresh: true,
    backGroundImageUrl: '',
    logoType: '',
    favIconUrl: '',
    titleWeb: '',
    countryCode: '',
    videoBackground: '',
    hasMarketingCampaign: null,
    markets: [],
    qrCodeLogo: '',
    currentMarket: null,
    isoLogo: null,
    media: [],
    platformMedia: [],
    publicKeyStripe: null,
    domainTarget: null,
    isAppReloadRequired: false,
    isEmbedded: false,
    platformName: '',
    isPlatform: undefined,
    overrideReady: false,
  },
  action,
) => {
  switch (action.type) {
    case 'APP_READY':
      return { ...state, status: 'READY', language: action.payload };
    case 'SET_TENANT_ID':
      return { ...state, tenantId: action.payload };
    case 'SET_APP_DATA':
      return {
        ...state,
        name: action.payload.name,
        logoURL: action.payload.logoURL,
        backGroundImageUrl: action.payload.backGroundImageUrl,
        logoType: action.payload.logoType,
        favIconUrl: action.payload.favIconUrl,
        titleWeb: action.payload.titleWeb,
        countryCode: action.payload.countryCode,
        videoBackground: action.payload.videoBackground,
        hasMarketingCampaign: action.payload.hasMarketingCampaign,
        markets: action.payload.markets,
        qrCodeLogo: action.payload.qrCodeLogo,
        currentMarket: action.payload.markets.length === 1 ? action.payload.markets[0] : null,
        isoLogo: action.payload.media.find((m) => m.type === 'ISO_LOGO'),
        media: action.payload.media,
        platformMedia: action.payload.isPlatform ? action.payload.media : [],
        publicKeyStripe: action.payload.publicKeyStripe,
        domainTarget: action.payload.domainTarget,
        tenantId: action.payload.tenantId,
        platformName: action.payload.titleWeb,
        isPlatform: action.payload.isPlatform,
      };
    case 'OVERRIDE_APP_DATA':
      return {
        ...state,
        name: action.payload.name,
        logoURL: action.payload.logoURL,
        //backGroundImageUrl: action.payload.backGroundImageUrl,
        logoType: action.payload.logoType,
        favIconUrl: action.payload.favIconUrl,
        titleWeb: action.payload.titleWeb,
        countryCode: action.payload.countryCode,
        //videoBackground: action.payload.videoBackground,
        hasMarketingCampaign: action.payload.hasMarketingCampaign,
        markets: action.payload.markets,
        qrCodeLogo: action.payload.qrCodeLogo,
        isoLogo: action.payload.media.find((m) => m.type === 'ISO_LOGO'),
        media: action.payload.media,
        //publicKeyStripe: action.payload.publicKeyStripe,
        //domainTarget: action.payload.domainTarget,
        tenantId: action.payload.tenantId,
        overrideReady: true,
        //isPlatform: action.payload.isPlatform,
      };
    case 'SET_MARKET':
      return {
        ...state,
        currentMarket: action.payload,
      };
    case 'SET_CAN_REFRESH':
      return { ...state, canRefresh: action.payload };
    case 'SET_LANGUAGE':
      return { ...state, language: action.payload };
    case 'SET_IS_APP_RELOAD_REQUIRED':
      return { ...state, isAppReloadRequired: action.payload };
    case 'SET_IS_EMBEDDED':
      return { ...state, isEmbedded: action.payload };
    case 'ASSOCIATES_LOGOUT':
      return { ...state, overrideReady: false };
    default:
      return state;
  }
};
